<template>
    <CustomDialog v-model="isVisible" :defaultTitle="$t('checkout.sale.tracking')" heightClass="ppv2-max-h-[60vh]">
        <template #content>
            <div class="ppv2-space-y-4">
                <BaseSelect
                    id="seller"
                    v-model="selectedSellerId"
                    :label="$t('checkout.sale.seller')"
                    :options="staffOptions"
                    optionLabel="label"
                    optionValue="value"
                    :placeholder="$t('checkout.sale.none')"
                    :clearable="true"
                    fixed-dropdown
                />

                <BaseSelect
                    id="practioner"
                    v-model="selectedAdviserId"
                    :label="$t('checkout.sale.adviser')"
                    :options="staffOptions"
                    optionLabel="label"
                    optionValue="value"
                    :placeholder="$t('checkout.sale.none')"
                    :clearable="true"
                    fixed-dropdown
                />
            </div>
        </template>

        <template #actions>
            <BaseButton
                variant="outline"
                @click="closeModal"
                customClass="!ppv2-min-h-[40px] ppv2-bg-white dark:ppv2-bg-dark-popup"
                :customHeight="43"
            >
                {{ $t('common.cancel') }}
            </BaseButton>
            <BaseButton variant="primary" @click="editSeller" customClass="!ppv2-min-h-[40px]" :customHeight="43">
                {{ $t('common.validate') }}
            </BaseButton>
        </template>
    </CustomDialog>
</template>

<script>
import ApiManager from './_core/ApiManager'
import CustomDialog from '../../Shared/CustomDialog.vue'
import BaseSelect from '../../Shared/BaseSelect.vue'
import BaseButton from '../../Shared/BaseButton.vue'

export default {
    components: {
        CustomDialog,
        BaseSelect,
        BaseButton,
    },
    props: ['cartRowId', 'sellerId', 'adviserId'],
    data: () => ({
        staffs: [],
        selectedSellerId: null,
        selectedAdviserId: null,
        isVisible: true,
    }),
    computed: {
        staffOptions() {
            return this.staffs.map((staff) => ({
                value: staff.id,
                label: `${staff.first_name} ${staff.last_name}`,
            }))
        },
    },
    async mounted() {
        await ApiManager.getAllStaffs().then((res) => (this.staffs = res))
        this.selectedSellerId = this.sellerId
        this.selectedAdviserId = this.adviserId
    },
    methods: {
        async editSeller() {
            await ApiManager.editSeller(this.cartRowId, this.selectedSellerId, this.selectedAdviserId).then(() => {
                this.closeModal()
                window.location.reload()
            })
        },
        closeModal() {
            this.isVisible = false
            this.$emit('hide-staff-modal')
        },
    },
}
</script>

<style></style>
